// extracted by mini-css-extract-plugin
export default {"customButton":"ButtonSmall_customButton__Rw2zX"};